function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".th_svg__cls-3{fill:#ed1c24}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#f0f0f0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10a9.91 9.91 0 00.46 3h19.08a10 10 0 000-6H.46A9.91 9.91 0 000 10z",
  fill: "#251d4f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "th_svg__cls-3",
  d: "M2 4h16A10 10 0 002 4zM18 16H2a10 10 0 0016 0z"
});

function SvgTh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "th_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjBmMGYwO30uY2xzLTJ7ZmlsbDojMjUxZDRmO30uY2xzLTN7ZmlsbDojZWQxYzI0O308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMCwxMGE5LjkxLDkuOTEsMCwwLDAsLjQ2LDNIMTkuNTRhMTAsMTAsMCwwLDAsMC02SC40NkE5LjkxLDkuOTEsMCwwLDAsMCwxMFoiLz48cGF0aCBjbGFzcz0iY2xzLTMiIGQ9Ik0yLDRIMThBMTAsMTAsMCwwLDAsMiw0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMyIgZD0iTTE4LDE2SDJhMTAsMTAsMCwwLDAsMTYsMFoiLz48L3N2Zz4=";
export { SvgTh as ReactComponent };